import { render } from "./NewSelect.vue?vue&type=template&id=9be56518&scoped=true"
import script from "./NewSelect.vue?vue&type=script&lang=js"
export * from "./NewSelect.vue?vue&type=script&lang=js"

import "./NewSelect.vue?vue&type=style&index=0&id=9be56518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be56518"]])

export default __exports__